module.exports = __webpack_public_path__ + "static/media/supported.66f7f08c.mp3";